import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const getUscitaTemp = () => {
  const tipoUscitaTempSelector = document.getElementById('tipo_uscita_temp');
  if (!tipoUscitaTempSelector) return;

  const dataSet = tipoUscitaTempSelector.dataset;

  if (dataSet.refreshTipiUscita === 'true') {
    const dateOut = document.getElementById('guest_status_date_out');

    $('#guest_status_date_out').on('change', async (e) => {
      Loader.show();
      const dateString = e.target.value;

      const baseUrl = window.config.ePersonamService.ePersonamHost;
      const url = `${baseUrl}${dataSet.refreshUrl}`;

      apiConnector()
        .get(url, {
          params: { date: dateString },
        })
        .then(({ data }) => {
          $('#tipo_uscita_temp').empty().select2({
            data: data,
            theme: 'bootstrap',
            include_blank: false,
            allowClear: true,
            minimumResultsForSearch: -1,
            placeholder: 'Seleziona una motivazione',
          });

          Loader.hide();
        });
    });
  }
};

const init = () => {
  try {
    getUscitaTemp();
  } catch (e) {
    errorManager(e);
  }
};

window.GetUscitaTemp = {
  init: init,
};
